<template>
<div>

<ContentHeader :title="$store.state.languages.lang_phrases.kullanici_bilgileri"  :show_button="false" ></ContentHeader>
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="!loading">
<div class="mt-4">


<template v-if="!item.userdatachecked">
<Message severity="error">{{$store.state.languages.lang_phrases.lutfen_kullanici_bilgilerinizi_guncelleyin}}</Message>
</template>

<ClickEditInputText  :title="$store.state.languages.lang_phrases.kullanici_ismi" :value="item.name" valkey="name" @dataChanged="dataChanged" />
<ClickEditInputText  :title="$store.state.languages.lang_phrases.kulllanici_email" :value="item.email" valkey="email" @dataChanged="dataChanged" />
<template v-if="$route.params.id=='profile'">
  <ClickEditInputText  :title="$store.state.languages.lang_phrases.sifre" :value="item.password" valkey="password" @dataChanged="dataChanged" />
</template>
<template v-else>
  <ClickEditMultiSelect :title="$store.state.languages.lang_phrases.kullanici_rolleri" :value="item.userroles" :options="roles" valkey="userroles"  @dataChanged="dataChanged"  />
</template>


<div class="grid" v-if="!supplier">
<div class="col-3 md:col-2"><p class="click_edit_value_title">Kullanıcı Auth Sayfası:</p></div>
<div class="col-9 md:col-10">
  <template v-if="item.reset_string">
    <Button type="button"  
    icon="pi pi-copy"  
    class="p-button-primary p-button-outlined p-button-sm mt-3"  
    @click="copyLink(appurl+'/reset-password/'+item.reset_string)"
    v-tooltip.right="{ value: 'Kopyala', disabled: false,class: 'custom-top-tooltip' }"
     />
  </template>
  <template v-else>
      <Button type="button" label="Sıfırlama linki gönder" class="p-button-primary p-button-outlined p-button-sm mt-3" @click="sendResetPassword"></Button>
    
  </template>
  
</div>

  </div>


</div>
</template>



</div>
</template>

<script>
export default {

  name: 'UserGeneral',

  data () {
    return {
      item:null,
      loading:true,
      roles:[
        {
          name:"Admin",
          id:"admin"
        },
        {
          name:"Planner",
          id:"planner"
        },
        {
          name:"Auditor",
          id:"auditor"
        },        
        {
          name:"Tecnical Auditor",
          id:"technical_auditor"
        }
        ],
    }
  },  
  computed:{
    appurl()
    {
      let api =  process.env.VUE_APP_APP_ROOT
      return api
    },
    supplier()
    {
      let userroles = this.$store.state.auth.user.userroles.map((item)=>{return item.name})
      if(userroles.includes("supplier"))
      {
        return true
      }
      return false

    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
     sendResetPassword()
    {
      let formdata = new FormData()
      formdata.append("email",this.item.email)
      this.generalSubmission(formdata,"send_reset_password",this.aftersendResetPassword)
    },
    aftersendResetPassword(response)
    {
      this.getData()
    },
    copyLink(link)
    {
      navigator.clipboard.writeText(link);
    },
    async getData()
    {
      
      let item
      if(this.$route.params.id=="profile")
      {
        item = await this.generalApiGetWithoutLoader("user/profile")
        await this.$store.dispatch('users/setUser',this.item) 
      }
      else
      {
        item = await this.generalApiGetWithoutLoader("user/"+this.$route.params.id)
        await this.$store.dispatch('users/setUser',this.item) 
      }
      await console.log(item);
      await this.$store.dispatch('users/setUser',item) 

      item = await this.mapUserRoles(item)
      this.item = await item
      this.loading = await false
    },
    mapUserRoles(user)
    {
      let arr = []
      for(let element of user.userroles)
      {
        element.id = element.name
        arr.push(element)
      }
      user.userroles = arr
      return user

    },
    dataChanged(data)
    {
      console.log(data.value)
      console.log(data.key)
      let formdata = new FormData()
      
      if(data.key=="userroles")
      {
        formdata.append(data.key,JSON.stringify(data.value))
      }
      else
      {
        formdata.append(data.key,data.value)
      }
      //return false
      this.generalSubmission(formdata,"user/"+this.item.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log("data changed");
      console.log(response.data);
      this.$store.dispatch('users/setUser',response.data) 
      let item = this.mapUserRoles(response.data)
      this.item = item
      
      
    }
   
    
    
  }
};
</script>

<style lang="css" scoped>
</style>